import React, { useEffect, useState } from 'react'
import PubSub from 'pubsub-js'

import User from '@js/common/user'

import Modal from '@f/components/Modal'
import BauortModal from '@f-fertighaus/widgets/BauortModal'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const ProximityCheck = ({
  deliveryRegions,
  alternativeMessage,
  vendorName,
  version = 'default'
}) => {
  const modal = new Modal()

  const [location, setLocation] = useState(User.getLocation())

  const openModal = () => {
    modal.openModal({
      component: <BauortModal />
    })
  }

  let psLocation_Update = null
  useEffect(() => {
    psLocation_Update = PubSub.subscribe('QUERYUPDATE', () => {
      let location = User.getLocation()
      setLocation(location)
    })

    return () => {
      PubSub.unsubscribe(psLocation_Update)
    }
  }, [])

  if (!location.postcode) {
    return (
      <>
        <CTA type='text-primary' className='[ f-t-body ]' onClick={openModal}>
          {version !== 'text' ? (
            <Icon
              icon='pin-16px'
              className='[ f-icon-020 f-m-r-010 f-c-st-ter ]'
            />
          ) : null}
          Bauort prüfen
        </CTA>
      </>
    )
  }

  let container = /vendor-/.test(document.body.dataset.pagetype)
    ? 'Vendor'
    : 'House'
  let available =
    deliveryRegions.indexOf(location.postcode) < 0 ? 'unavailable' : 'available'

  let content = {
    availableHouse: `Dieses Haus kann in ${location.city} und Umgebung gebaut werden`,
    availableVendor: `Dieser Anbieter baut in ${location.city} und Umgebung`,
    unavailableHouse: `Dieses Haus kann leider nicht in ${location.city} gebaut werden`,
    unavailableVendor: `Dieser Anbieter baut leider nicht in ${location.city}`
  }

  if (alternativeMessage) {
    content.unavailableHouse = `Wir haben derzeit leider keine Angebote von ${vendorName} in ${location.city}.`
    content.unavailableVendor = `Wir haben derzeit leider keine Angebote von ${vendorName} in ${location.city}.`
  }

  return version === 'text' ? (
    <>
      {content[available + container].replace('Dieser Anbieter baut', 'Baut')}
    </>
  ) : (
    <>
      <Icon
        icon='pin-16px'
        className='[ f-pos-rel f-icon-020 f-m-r-010 f-c-st-ter f-icon-t-mini ]'
        style={{ float: 'left', top: '2px' }}
      />
      <span className='[ f-d-bl f-m-l-030 f-t-mini f-c-fo-pri ]'>
        {content[available + container]}
      </span>
    </>
  )
}

export default ProximityCheck
